import React, { Component } from 'react';

//material-ui
import Grid from '@material-ui/core/Grid';
// Components
import Carousel from './Collapse';
import Header from './Header';
import Footer from './Footer';
import Description from './Description';
import ContainerBtn from './ContainerBtn';
import Simulacion from './Simulacion';
import $ from 'jquery';
import axios from 'axios';

// persistencia en redux
import {
    resetToInitialState,
    setParametria
} from '../../../actions/actions';

import {connect} from 'react-redux';

import { traerConfiguracionBackend } from '../Utils/BackendUnificado';

class LandingPage extends Component {
    constructor(props) {
        super(props);
        this.state={dataDiasFeriados:{
            formatoFecha:"",
            listaFeriados:[],
            statusCode:""
        }};        
    }

    componentDidMount(){
        this.props.resetToInitialState();
        localStorage.removeItem('url');
        traerConfiguracionBackend(true, false)
            .then(res2 => this.loadData())
            .catch(err => this.loadData());
    }

    loadData(){
        this.getDiasFeriados();
        //ESTA MAL, SE ESTAN MEZCLANDO LAS CAPAS!!!
        axios({
            method: 'get',
            url: localStorage.getItem('url') + '/api/plazoFijo/parametria'
        },{withCredentials: true}).then((response) => {
            
            if (response.status === 200) {
                this.props.setParametria(response.data);                
                return;
            } else {
                window.location="/onboarding/plazo-fijo/error";
            }
        }).catch(error => {
           console.error("---------------------")
           console.error(error)
           console.error("---------------------")

           window.location="/onboarding/plazo-fijo/error";
        });
    }

    getDiasFeriados(){
        axios({
            method: 'get',
            url: localStorage.getItem('url') + '/api/plazoFijo/diasFeriados'
        },{withCredentials: true}).then((response) => {
            if (response.data.statusCode === "200") {
                this.setState({dataDiasFeriados:response.data});
                return;
            } else {
                //this.props.history.push('/plazo-fijo/error');
                window.location="/onboarding/plazo-fijo/error";
            }
        }).catch(error => {
           //this.props.history.push('/plazo-fijo/error');
           window.location="/onboarding/plazo-fijo/error";
        });
    }

    render() {
        const { classes, plazoFijoLandingPage } = this.props;

        if(typeof plazoFijoLandingPage.parametria == "undefined" || Object.keys(plazoFijoLandingPage.parametria).length === 0 )
            return null

        return (
            <div className="landing-page">
                <Header />
                <ContainerBtn history={this.props.history} dataFeriados={this.state.dataDiasFeriados}/>
                <Description />
                <Simulacion />
                <ContainerBtn history={this.props.history} dataFeriados={this.state.dataDiasFeriados}/>
                <Carousel />
                <Footer />
            </div>
        );
    }
}

const mapDispatchToProps = {
    resetToInitialState,
    setParametria 
}

const mapStateToProps = (state) => {
    return ({
      plazoFijoLandingPage: state.plazoFijoLandingPage
    });
  }

export default connect( mapStateToProps, mapDispatchToProps )( LandingPage ) ;



// WEBPACK FOOTER //
// ./src/components/PlazoFijo/landingPage/LandingPage.js